import { Card } from "@yleisradio/areena-types";

import { SetPlayingRecommendation } from "../components/recommendations/recommendationTypes";
import { PlayerUpdateEvent } from "../types/public";

import { getYleIdFromCardOrThrow } from "./areenaApi";
import { getRecommendationUrl } from "./areenaLinks";
import { navigateTo } from "./navigation";

export const playRecommendation = ({
  index,
  language,
  playProgram,
  recommendation,
  setPlayingRecommendation,
  update
}: {
  index: number;
  language: string;
  playProgram: boolean;
  recommendation: Card;
  setPlayingRecommendation: SetPlayingRecommendation;
  update: PlayerUpdateEvent;
}): void => {
  const recommendationProgramId = getYleIdFromCardOrThrow(recommendation);

  if (playProgram) {
    setPlayingRecommendation(index);
    update({
      autoplay: true,
      programId: recommendationProgramId
    });
  } else {
    navigateTo(
      getRecommendationUrl({
        index,
        language,
        programId: recommendationProgramId
      })
    );
  }
};
